import { AlertTriangle, X } from 'lucide-react';
import { useState } from 'react';
import { useSubscriptionHealth } from '../../hooks/useSubscriptionHealth';

const dateTimeFormatter = new Intl.DateTimeFormat('fa-IR', {
  dateStyle: 'medium',
  timeStyle: 'short',
});
const numberFormatter = new Intl.NumberFormat('fa-IR');

function formatDateTime(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return dateTimeFormatter.format(date);
}

function buildTimeline({ lastOkAt, lastCheckedAt, consecutiveFailures }) {
  const failureCount = Number.isFinite(Number(consecutiveFailures))
    ? Math.max(0, Math.trunc(Number(consecutiveFailures)))
    : 0;
  const countText = numberFormatter.format(failureCount);
  const lastOkText = formatDateTime(lastOkAt);
  const lastCheckedText = formatDateTime(lastCheckedAt);

  if (lastOkText) {
    return `آخرین پاسخ موفق در ${lastOkText} ثبت شد؛ از آن زمان ${countText} بررسی پیاپی ناموفق بوده است.`;
  }
  if (lastCheckedText) {
    return `اختلال در بررسی ${lastCheckedText} دیده شد؛ ${countText} بررسی پیاپی ناموفق ثبت شده است.`;
  }
  return `زمان آغاز اختلال هنوز مشخص نیست؛ ${countText} بررسی پیاپی ناموفق ثبت شده است.`;
}

export default function SubscriptionHealthBanner() {
  const health = useSubscriptionHealth();
  const outageKey = health.lastOkAt ?? 'no-last-ok';
  const [dismissedOutageKey, setDismissedOutageKey] = useState(null);

  if (health.status !== 'failed' || dismissedOutageKey === outageKey) return null;

  return (
    <div className="subscription-health-banner" role="status" aria-live="polite" dir="rtl">
      <div className="subscription-health-banner__icon" aria-hidden="true">
        <AlertTriangle size={20} strokeWidth={2.25} />
      </div>
      <div className="subscription-health-banner__content">
        <div className="subscription-health-banner__title">اشتراک ChatGPT پاسخ نمی‌دهد</div>
        <p className="subscription-health-banner__timeline">{buildTimeline(health)}</p>
        <p className="subscription-health-banner__reassurance">
          سرویس‌دهی به مشتریان همچنان ادامه دارد. بخش‌های متصل به اشتراک به‌صورت خودکار از مسیر جایگزین OpenRouter استفاده می‌کنند.
        </p>
        <p className="subscription-health-banner__action">توکن Codex یا broker را بررسی کنید.</p>
        {health.lastError && (
          <p className="subscription-health-banner__error">
            پیام خطا: <span dir="auto">{health.lastError}</span>
          </p>
        )}
      </div>
      <button
        type="button"
        className="subscription-health-banner__close"
        onClick={() => setDismissedOutageKey(outageKey)}
        aria-label="بستن هشدار سلامت اشتراک"
        title="بستن"
      >
        <X size={18} aria-hidden="true" />
      </button>
    </div>
  );
}
